'use client';

import { c as _c } from "react/compiler-runtime";
import { IdentityImagePicker } from '@/components/images/identity-picker';
interface HeroPickerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Owning user's id. Drives palette + per-variant base seed. */
  userId: string;
  currentHeroUrl: string | null;
  /** Display name pre-fills the Search tab. Pass null/'' if unknown. */
  searchSeedQuery?: string;
  /** Called after a successful save with the new URL. */
  onHeroChange: (url: string) => void;
}

/**
 * Hero picker — thin wrapper around `<IdentityImagePicker kind="hero">`.
 * Search → Pattern → Upload tabs.
 */
export function HeroPicker(props) {
  const $ = _c(7);
  const t0 = props.searchSeedQuery ?? "";
  let t1;
  if ($[0] !== props.currentHeroUrl || $[1] !== props.onHeroChange || $[2] !== props.onOpenChange || $[3] !== props.open || $[4] !== props.userId || $[5] !== t0) {
    t1 = <IdentityImagePicker kind="hero" open={props.open} onOpenChange={props.onOpenChange} userId={props.userId} currentUrl={props.currentHeroUrl} searchSeedQuery={t0} onChange={props.onHeroChange} />;
    $[0] = props.currentHeroUrl;
    $[1] = props.onHeroChange;
    $[2] = props.onOpenChange;
    $[3] = props.open;
    $[4] = props.userId;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}